module.exports = "/assets/heart.png?eB6V7lA";